import {EntityModel} from "@fedeltapointofsale/data-client";
import {CreditInvoiceData} from "./credit-invoice.data";
import {Injectable, Injector} from "@angular/core";
@Injectable()
export class CreditInvoiceEntityModel extends EntityModel<CreditInvoiceData> {
    constructor(injector: Injector) {
        super(injector, CreditInvoiceData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
